import * as React from "react";
import { MuiTextFieldType } from "../../common/muiFieldTypes/muiTextFieldType";
import { MuiMultipleChoiceFieldType } from "../../common/muiFieldTypes/muiMultiChoiceFieldType";
import {
  CircularProgress,
  FormHelperText,
  TableContainer,
} from "@mui/material";
import { AutoAddTable } from "./AutoAddTable";
import { OrangeTextButton } from "../../common/OrangeTextButton";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { handleImmixServerInput } from "./CameraAutoAddUtils/handleImmixServerInput";
import { handleImmixPortInput } from "./CameraAutoAddUtils/handleImmixPortInput";
import { handleDiceServerInput } from "./CameraAutoAddUtils/handleDiceServerInput";
import { handleDicePortInput } from "./CameraAutoAddUtils/handleDicePortInput";
import { handleSubmitAutoAddCameras } from "./CameraAutoAddUtils/handleSubmitAutoAddCameras";
import { useNavigate } from "react-router-dom";
import { handleSureviewServerInput } from "./CameraAutoAddUtils/handleSureViewServerInput";
import { handleSureviewSubjectInput } from "./CameraAutoAddUtils/handleSureViewSubjectInput";
import Alert from "@mui/material/Alert";
import {
  Autocomplete,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import {
  handleFixCameras,
  FixCamerasResult,
  EMPTY_FIX_RESULT,
  hasMovedRecordingServer,
} from "./CameraAutoAddUtils/handleFixCameras";
import BuildIcon from "@mui/icons-material/Build";
import { AutoAddSearchBar } from "./AutoAddSearchBar";
import { Dispatcher } from "../Sites/SiteAboutPage/SiteAboutPageUtils/siteAboutInterfaces";
import { getAutoAddData } from "./CameraAutoAddUtils/getAutoAddData";
import { defaultAutoAddProducts } from "./CameraAutoAddUtils/defaultAutoAddProducts";
import { createApi } from "../../utils/createApi";
import { AxiosResponse } from "axios";
import ErrorBoundary from "../../../ErrorBoundary";
import useWindowDimensions from "../../common/useWindowDimensions";
import { createMinReqHelperText } from "../../common/onBoardingWizardFieldTypes/createMinReqHelperText";
import SyncIcon from "@mui/icons-material/Sync";
import { handleRefreshCameraList } from "./CameraAutoAddUtils/handleRefreshCameraList";
import { handleSentinelInput } from "./CameraAutoAddUtils/handleSentinelInput";
import {
  applyPatriotAlertPatch,
  handlePatriotInput,
} from "./CameraAutoAddUtils/handlePatriotInput";
import { PatriotDeliveryChoice } from "../../common/PatriotDeliveryChoice";
import { handleEvalinkInput } from "./CameraAutoAddUtils/handleEvalinkInput";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import { MuiCheckBoxFieldType } from "../../common/muiFieldTypes/muiCheckBoxFieldType";
import { handleImmixDrawIgnoreZonesInput } from "./CameraAutoAddUtils/handleImmixDrawIgnoreZonesInput";
import { handleDiceDrawIgnoreZonesInput } from "./CameraAutoAddUtils/handleDiceDrawIgnoreZonesInput";
import { useCameraAutoAddStore } from "./CameraAutoAddStore/cameraAutoAddStore";

export const CameraAutoAddScreen = ({
  setVisibleScreen,
  setLargerScreen,
  largerScreen,
  setCameraCheckFinsihedAlertOpen,
  setGoodCameras,
  setConnectivityCameras,
  setLowResolutionCameras,
  setCameraCheckResultDownloadURL,
}: {
  setVisibleScreen: any;
  setLargerScreen: Dispatcher<boolean>;
  largerScreen: boolean;
  setCameraCheckFinsihedAlertOpen: any;
  setGoodCameras: any;
  setConnectivityCameras: any;
  setLowResolutionCameras: any;
  setCameraCheckResultDownloadURL: any;
}) => {
  const { searchingCameras, setPage, setRowsPerPage } = useCameraAutoAddStore();

  const [camerasList, setCamerasList] = React.useState<any>({});

  const [camerasObject, setCamerasObject] = React.useState([]);

  const [fetchingAutoAddData, setFetchingAutoAddData] = React.useState(true);

  const [clientProducts, setClientProducts] = React.useState([]);

  const [selectedProducts, setSelectedProducts] = React.useState([]);

  const [checkboxesChecked, setCheckboxesChecked] = React.useState<any>({});

  const [immixSite, setImmixSite] = React.useState(false);

  const [diceSite, setDiceSite] = React.useState(false);

  const [sureViewSite, setSureviewSite] = React.useState(false);

  const [sentinelSite, setSentinelSite] = React.useState(false);

  const [patriotSite, setPatriotSite] = React.useState(false);

  const [evalinkSite, setEvalinkSite] = React.useState(false);

  const [hanwhaSite, setHanwhaSite] = React.useState(false);

  const [autoAddError, setAutoAddError] = React.useState(
    localStorage.autoAddError
  );

  const [productsArray, setProductsArray] = React.useState([]);

  const [autoAddSiteInfo, setAutoAddSiteInfo] = React.useState<any>({});

  const [streamPatchObject, setStreamPatchObject] = React.useState<any>({
    resolution: "",
    stream_type: "",
    stream_quality: "",
    codec: "",
  });

  const [streamChangesMade, setStreamChangesMade] = React.useState(false);

  const [fixingCameras, setFixingCameras] = React.useState(false);

  const [fixResult, setFixResult] =
    React.useState<FixCamerasResult>(EMPTY_FIX_RESULT);

  const fixChangeCount =
    fixResult.camerasChanged.length +
    fixResult.uidsFixed +
    fixResult.updateMessages.length;

  const camerasMovedServers = (camerasList.results || []).some(
    hasMovedRecordingServer
  );

  const { width } = useWindowDimensions();

  const serverOptions = [
    ["US SMTP Server", "us-smtp.sureviewops.com"],
    ["EU SMTP Server", "eu-smtp.sureviewops.com"],
  ];

  const optionsIds = new Map();
  const optionNames = new Map();
  serverOptions.forEach((option: any) => {
    optionsIds.set(option[0], option[1]);
  });
  serverOptions.forEach((option: any) => {
    optionNames.set(option[1], option[0]);
  });

  const alarmOptions = JSON.parse(localStorage.alarmOptions);

  const alarmIds = new Map();
  alarmOptions.forEach((object: any) => {
    alarmIds.set(object.value, object.name);
  });

  const integrationsTypes = JSON.parse(localStorage.integrationTypes);

  const integrationIds = new Map();
  integrationsTypes.forEach((object: any) => {
    integrationIds.set(object.id, object.name);
  });

  const navigate = useNavigate();

  const [additionalFieldNamesArray, setAdditionalFieldNamesArray] =
    React.useState(JSON.parse(localStorage?.additionalFieldNamesArray || "[]"));

  const immixAlertPostObject = JSON.parse(localStorage.immixAlertPostObject);

  const diceAlertPostObject = JSON.parse(
    localStorage.diceAlertPostObject || "{}"
  );

  const sentinelAlertPostObject = JSON.parse(
    localStorage.sentinelAlertPostObject
  );

  const patriotAlertPostObject = JSON.parse(
    localStorage.patriotAlertPostObject || "{}"
  );

  // handlePatriotInput / applyPatriotAlertPatch write localStorage before
  // setting state, so the delivery choice re-derives on the re-render.

  const evalinkAlertPostObject = JSON.parse(
    localStorage.evalinkAlertPostObject || "{}"
  );

  React.useEffect(() => {
    // Reset pagination state on component mount
    setPage(0);
    setRowsPerPage(10);

    getAutoAddData(
      setCamerasList,
      setCamerasObject,
      setFetchingAutoAddData,
      checkboxesChecked,
      setCheckboxesChecked,
      setClientProducts,
      setImmixSite,
      setSureviewSite,
      setProductsArray,
      setAutoAddSiteInfo,
      navigate
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Cleanup timeout on unmount
  React.useEffect(() => {
    return () => {
      if (helperTextTimeoutRef.current) {
        clearTimeout(helperTextTimeoutRef.current);
      }
    };
  }, []);

  React.useEffect(() => {
    if (Object.keys(autoAddSiteInfo).length > 0) {
      if (alarmIds.get(autoAddSiteInfo.default_alarm) === "Immix") {
        setImmixSite(true);
      }
      if (alarmIds.get(autoAddSiteInfo.default_alarm) === "Dice") {
        setDiceSite(true);
      }
      if (alarmIds.get(autoAddSiteInfo.default_alarm) === "SureView") {
        setSureviewSite(true);
      }
      if (alarmIds.get(autoAddSiteInfo.default_alarm) === "Sentinel") {
        setSentinelSite(true);
      }
      if (alarmIds.get(autoAddSiteInfo.default_alarm) === "Patriot") {
        setPatriotSite(true);
      }
      if (alarmIds.get(autoAddSiteInfo.default_alarm) === "Evalink") {
        setEvalinkSite(true);
      }
      if (
        integrationIds.get(Number(localStorage.integrationType)) ===
        "digital_watchdog"
      ) {
        setHanwhaSite(true);
      }
    }
  }, [autoAddSiteInfo]);

  const buttonText = (
    <>
      Save Changes
      <ArrowForwardIcon />
    </>
  );

  // Lightweight reload of the NVR camera list (no NVR re-poll) so the deployed
  // names and servers refresh after a "Fix Cameras" run and the old -> new diffs clear.
  const refreshCameraListLight = () => {
    getAutoAddData(
      setCamerasList,
      setCamerasObject,
      setFetchingAutoAddData,
      checkboxesChecked,
      setCheckboxesChecked,
      setClientProducts,
      setImmixSite,
      setSureviewSite,
      setProductsArray,
      setAutoAddSiteInfo,
      navigate
    );
  };

  const [helperText, setHelperText] = React.useState("");

  // Pre-select products once the site's product list loads: the per-product
  // checkbox columns only appear when a product is selected, so an empty box
  // leaves no way to pick cameras. Never selects every product by default.
  React.useEffect(() => {
    if (!Array.isArray(productsArray) || productsArray.length === 0) return;
    if (selectedProducts.length > 0) return;
    let cancelled = false;
    const apply = (siteProductIds: any) => {
      const picked = defaultAutoAddProducts(productsArray, siteProductIds);
      if (cancelled || picked.length === 0) return;
      setSelectedProducts(picked as any);
      createMinReqHelperText(setHelperText, picked, productsArray, navigate);
    };
    if (productsArray.length === 1) {
      apply([]);
    } else {
      createApi(``)
        .get(`customer/${localStorage.siteId}/camera_onboarding_forms/`)
        .then(
          (response: AxiosResponse) =>
            apply(response.data?.initial_data?.products),
          () => undefined
        );
    }
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productsArray]);

  const helperTextTimeoutRef = React.useRef<NodeJS.Timeout | null>(null);

  return (
    <div>
      {fetchingAutoAddData ? (
        <div className="flex flex-col items-center justify-center pt-[200px]">
          <CircularProgress color="warning" />
          <p className="font-mulish text-[20px] pt-[20px] text-center">
            Fetching Cameras.
            <br />
            <p className="font-mulish text-[16px]">
              This may take a few seconds.
            </p>
          </p>
        </div>
      ) : (
        <ErrorBoundary>
          <div>
            {autoAddError && (
              <div className="absolute w-[600px] h-[50px]">
                <Alert
                  severity="error"
                  onClose={() => {
                    setAutoAddError(false);
                    localStorage.removeItem("autoAddError");
                  }}
                >
                  <p className="font-mulish font-bold text-[16px]">
                    Problem adding Camera(s). Please try again.
                  </p>
                </Alert>
              </div>
            )}
            <Dialog
              open={fixResult.open}
              onClose={() => setFixResult({ ...fixResult, open: false })}
            >
              <DialogTitle sx={{ fontFamily: "Mulish" }}>
                {fixResult.error
                  ? "Couldn't fix cameras"
                  : fixChangeCount > 0
                  ? "Cameras updated"
                  : "No cameras needed fixing"}
              </DialogTitle>
              <DialogContent sx={{ fontFamily: "Mulish" }}>
                {fixResult.error ? (
                  <p className="font-mulish">
                    {fixResult.errorMessage ||
                      "Something went wrong applying the NVR camera list. Please try again."}
                  </p>
                ) : fixChangeCount > 0 ? (
                  <>
                    <p className="font-mulish pb-[8px]">
                      These cameras now match the NVR (the camera id was
                      preserved). Sync the site to push the changes to the
                      connector.
                    </p>
                    {fixResult.updateMessages.length > 0 && (
                      <ul className="list-disc pl-[20px] pb-[8px] font-mulish">
                        {fixResult.updateMessages.map((text) => (
                          <li key={text}>{text}</li>
                        ))}
                      </ul>
                    )}
                    {fixResult.camerasChanged.length > 0 && (
                      <>
                        <p className="font-mulish font-bold">Renamed</p>
                        <ul className="list-disc pl-[20px] pb-[8px] font-mulish">
                          {fixResult.camerasChanged.map((camera: any) => (
                            <li key={camera.id}>{camera.camera_name}</li>
                          ))}
                        </ul>
                      </>
                    )}
                    {fixResult.uidsFixed > 0 && (
                      <p className="font-mulish">
                        Updated the device ID of {fixResult.uidsFixed} camera
                        {fixResult.uidsFixed === 1 ? "" : "s"}.
                      </p>
                    )}
                  </>
                ) : (
                  <p className="font-mulish">
                    All deployed cameras already match the NVR.
                  </p>
                )}
              </DialogContent>
              <DialogActions>
                <OrangeTextButton
                  text="Close"
                  disabled={false}
                  onClick={() => setFixResult({ ...fixResult, open: false })}
                />
              </DialogActions>
            </Dialog>
            {/* <div className='font-mulish absolute text-[#283E6D] top-[70px] right-[490px] text-[22px]'>Auto-Add Cameras</div> */}
            <div className="absolute top-[75px] right-[30px]">
              <OrangeTextButton
                onClick={() => {
                  localStorage.removeItem("autoAddError");
                  handleSubmitAutoAddCameras(
                    camerasObject,
                    setVisibleScreen,
                    setLargerScreen,
                    largerScreen,
                    setCameraCheckFinsihedAlertOpen,
                    setGoodCameras,
                    setConnectivityCameras,
                    setLowResolutionCameras,
                    setCameraCheckResultDownloadURL,
                    sentinelSite,
                    patriotSite,
                    streamChangesMade,
                    streamPatchObject,
                    navigate
                  );
                }}
                text={buttonText}
                disabled={!camerasList.results[0]}
              />
            </div>

            <div className="font-mulish  absolute text-[#283E6D] top-[80px] left-[20px] text-[18px]">
              Cameras
            </div>

            <div className="absolute top-[120px] left-[30px]">
              <div>
                <div>
                  <MuiMultipleChoiceFieldType
                    id="product_input"
                    options={clientProducts}
                    onChange={(event: any, value: any) => {
                      // Update selected products immediately for responsive UI
                      setSelectedProducts(value);
                      // Debounce the helper text API call to prevent blocking
                      // This prevents the API call from freezing the UI during rapid selections
                      if (helperTextTimeoutRef.current) {
                        clearTimeout(helperTextTimeoutRef.current);
                      }
                      helperTextTimeoutRef.current = setTimeout(() => {
                        createMinReqHelperText(
                          setHelperText,
                          value,
                          productsArray,
                          navigate
                        );
                      }, 300);
                    }}
                    stylingWidth={500}
                    label="Products"
                    helperText={helperText}
                    defaultValue={[]}
                    value={selectedProducts}
                  />
                </div>
                <br></br>
                <div className="relative left-[-15px]">
                  <TableContainer
                    sx={largerScreen ? { width: width - 25 } : { width: 560 }}
                  >
                    <div className="flex">
                      <div className="w-[350px]">
                        <AutoAddSearchBar
                          setCamerasList={setCamerasList}
                          setCamerasObject={setCamerasObject}
                          navigate={navigate}
                          productsArray={productsArray}
                          setCheckboxesChecked={setCheckboxesChecked}
                          checkboxesChecked={checkboxesChecked}
                        />
                      </div>
                      <div className="pl-15">
                        <OrangeTextButton
                          text={
                            <>
                              <SyncIcon fontSize="small" />
                              &nbsp; Refresh Camera List
                            </>
                          }
                          disabled={false}
                          onClick={() => {
                            setHelperText("");
                            handleRefreshCameraList(
                              setCamerasList,
                              setCamerasObject,
                              setFetchingAutoAddData,
                              checkboxesChecked,
                              setCheckboxesChecked,
                              setClientProducts,
                              setImmixSite,
                              setSureviewSite,
                              setProductsArray,
                              setSelectedProducts,
                              setAutoAddError,
                              setAutoAddSiteInfo,
                              navigate
                            );
                          }}
                        />
                      </div>
                      <div className="pl-15">
                        <OrangeTextButton
                          text={
                            fixingCameras ? (
                              <>
                                <CircularProgress size={16} color="inherit" />
                                &nbsp; Fixing Cameras...
                              </>
                            ) : (
                              <>
                                <BuildIcon fontSize="small" />
                                &nbsp; Fix Cameras
                              </>
                            )
                          }
                          disabled={fixingCameras || !camerasList.results?.[0]}
                          onClick={() => {
                            handleFixCameras(
                              setFixingCameras,
                              setFixResult,
                              refreshCameraListLight,
                              navigate
                            );
                          }}
                        />
                      </div>
                    </div>
                    {camerasMovedServers && (
                      <p className="font-mulish text-[13px] text-[#283E6D] px-[20px] pb-[8px]">
                        Some cameras moved to a new recording server (see
                        &quot;Old server&quot;). Click Fix Cameras to update
                        them.
                      </p>
                    )}
                    {searchingCameras && (
                      <div className="p-[20px]">
                        <CircularProgress color="warning" /> &nbsp; Searching
                        Cameras...
                      </div>
                    )}
                    {!searchingCameras && (
                      <AutoAddTable
                        camerasList={camerasList}
                        selectedProducts={selectedProducts}
                        camerasObject={camerasObject}
                        setCamerasObject={setCamerasObject}
                        checkboxesChecked={checkboxesChecked}
                        setCheckboxesChecked={setCheckboxesChecked}
                        additionalFieldNamesArray={additionalFieldNamesArray}
                        immixSite={immixSite}
                        diceSite={diceSite}
                        sureViewSite={sureViewSite}
                        productsArray={productsArray}
                        sentinelSite={sentinelSite}
                        patriotSite={patriotSite}
                        evalinkSite={evalinkSite}
                        setCamerasList={setCamerasList}
                        largerScreen={largerScreen}
                        hanwhaSite={hanwhaSite}
                      />
                    )}
                  </TableContainer>
                </div>
                {immixSite && (
                  <div>
                    <p className="relative h-[35px] font-mulish w-[300px] text-[#283E6D] text-[18px]">
                      Immix Alerts
                    </p>
                    <div className="relative h-[75px]">
                      <MuiTextFieldType
                        id="immixServerInput"
                        defaultValue={immixAlertPostObject.immix_server}
                        value=""
                        onChange={(event: any) => {
                          handleImmixServerInput(
                            camerasObject,
                            setCamerasObject,
                            event.target.value
                          );
                        }}
                        helperText=""
                        stylingWidth={300}
                        label="Immix Server"
                        error={false}
                      />
                    </div>
                    <div>
                      <MuiTextFieldType
                        id="immixPortInput"
                        defaultValue={immixAlertPostObject.immix_port}
                        value=""
                        onChange={(event: any) => {
                          handleImmixPortInput(
                            camerasObject,
                            setCamerasObject,
                            event.target.value
                          );
                        }}
                        helperText=""
                        stylingWidth={300}
                        label="Immix Port"
                        error={false}
                      />
                    </div>
                    <div className="pt-[10px]">
                      <MuiCheckBoxFieldType
                        id="drawIgnoreZones"
                        checked={false}
                        disabled={false}
                        label="Draw Ignore Zones"
                        onChange={(event: any) => {
                          handleImmixDrawIgnoreZonesInput(
                            camerasObject,
                            setCamerasObject,
                            event.target.checked
                          );
                        }}
                        helperText="If checked, draws ignore zones in the alert images."
                      />
                    </div>
                    <br></br>
                  </div>
                )}
                {diceSite && (
                  <div>
                    <p className="relative h-[35px] font-mulish w-[300px] text-[#283E6D] text-[18px]">
                      Dice Alerts
                    </p>
                    <div className="relative h-[75px]">
                      <MuiTextFieldType
                        id="diceServerInput"
                        defaultValue={diceAlertPostObject.dice_server}
                        value=""
                        onChange={(event: any) => {
                          handleDiceServerInput(
                            camerasObject,
                            setCamerasObject,
                            event.target.value
                          );
                        }}
                        helperText=""
                        stylingWidth={300}
                        label="Dice Server"
                        error={false}
                      />
                    </div>
                    <div>
                      <MuiTextFieldType
                        id="dicePortInput"
                        defaultValue={diceAlertPostObject.dice_port}
                        value=""
                        onChange={(event: any) => {
                          handleDicePortInput(
                            camerasObject,
                            setCamerasObject,
                            event.target.value
                          );
                        }}
                        helperText=""
                        stylingWidth={300}
                        label="Dice Port"
                        error={false}
                      />
                    </div>
                    <div className="pt-[10px]">
                      <MuiCheckBoxFieldType
                        id="diceDrawIgnoreZones"
                        checked={false}
                        disabled={false}
                        label="Draw Ignore Zones"
                        onChange={(event: any) => {
                          handleDiceDrawIgnoreZonesInput(
                            camerasObject,
                            setCamerasObject,
                            event.target.checked
                          );
                        }}
                        helperText="If checked, draws ignore zones in the alert images."
                      />
                    </div>
                    <br></br>
                  </div>
                )}
                {sureViewSite && (
                  <div>
                    <p className="relative h-[35px] font-mulish w-[300px] text-[#283E6D] text-[18px]">
                      Sureview Alerts
                    </p>
                    <div className="relative h-[75px]">
                      <Autocomplete
                        disablePortal
                        id="sureViewServer"
                        options={serverOptions.map((option: string[]) => {
                          return option[0];
                        })}
                        onChange={(event: any, newInputValue: any) => {
                          handleSureviewServerInput(
                            camerasObject,
                            setCamerasObject,
                            optionsIds.get(newInputValue)
                          );
                        }}
                        sx={{ width: 300 }}
                        renderInput={(params: any) => (
                          <TextField
                            {...params}
                            variant="standard"
                            label="Sureview Server"
                            autoComplete="off"
                            sx={{ width: 300 }}
                          />
                        )}
                      />
                    </div>
                    <div>
                      <MuiTextFieldType
                        id="sureViewSubject"
                        defaultValue=""
                        value=""
                        onChange={(event: any) => {
                          handleSureviewSubjectInput(
                            camerasObject,
                            setCamerasObject,
                            event.target.value
                          );
                        }}
                        helperText=""
                        stylingWidth={300}
                        label="Sureview Subject"
                        error={false}
                      />
                    </div>
                    <br></br>
                  </div>
                )}
                {sentinelSite && (
                  <div>
                    <p className="relative h-[35px] font-mulish w-[300px] text-[#283E6D] text-[18px]">
                      Sentinel Alerts
                    </p>
                    <div className="relative h-[75px]">
                      <MuiTextFieldType
                        id="sentinelServerInput"
                        defaultValue={sentinelAlertPostObject.sentinel_server}
                        value=""
                        onChange={(event: any) => {
                          handleSentinelInput(
                            setCamerasObject,
                            camerasObject,
                            event.target.value,
                            false,
                            null,
                            "sentinelServer"
                          );
                        }}
                        helperText=""
                        stylingWidth={300}
                        label="Sentinel Server"
                        error={false}
                      />
                    </div>
                    <div className="relative h-[75px]">
                      <MuiTextFieldType
                        id="sentinelSiteIdInput"
                        defaultValue={sentinelAlertPostObject.sentinel_site_id}
                        value=""
                        onChange={(event: any) => {
                          handleSentinelInput(
                            setCamerasObject,
                            camerasObject,
                            event.target.value,
                            false,
                            null,
                            "sentinelSiteId"
                          );
                        }}
                        helperText=""
                        stylingWidth={300}
                        label="Sentinel Site Id"
                        error={false}
                      />
                    </div>
                    <div className="relative h-[75px]">
                      <MuiTextFieldType
                        id="sentinelDeviceAddressInput"
                        defaultValue={
                          sentinelAlertPostObject.sentinel_device_address
                        }
                        value=""
                        onChange={(event: any) => {
                          handleSentinelInput(
                            setCamerasObject,
                            camerasObject,
                            event.target.value,
                            false,
                            null,
                            "sentinelDeviceAddress"
                          );
                        }}
                        helperText=""
                        stylingWidth={300}
                        label="Sentinel Device Address"
                        error={false}
                      />
                    </div>
                    <div className="relative h-[75px]">
                      <FormControlLabel
                        sx={{
                          fontFamily: "Mulish",
                          color: "#001943",
                        }}
                        label="Draw Ignore Zones"
                        control={
                          <Checkbox
                            color="primary"
                            defaultChecked={
                              sentinelAlertPostObject.draw_ignore_zones
                            }
                            onChange={(event, checked) => {
                              handleSentinelInput(
                                setCamerasObject,
                                camerasObject,
                                "",
                                checked,
                                null,
                                "drawIgnoreZones"
                              );
                            }}
                          />
                        }
                      />
                      <FormHelperText>
                        If checked, draws ignore zones in the alert images.
                      </FormHelperText>
                    </div>
                    <br></br>
                  </div>
                )}
                {evalinkSite && (
                  <div>
                    <p className="relative h-[35px] font-mulish w-[300px] text-[#283E6D] text-[18px]">
                      Evalink Alerts
                    </p>
                    <div className="relative h-[75px]">
                      <MuiTextFieldType
                        id="evalinkTokenInput"
                        defaultValue={evalinkAlertPostObject.evalink_token}
                        value=""
                        onChange={(event: any) => {
                          handleEvalinkInput(
                            setCamerasObject,
                            camerasObject,
                            event.target.value,
                            null,
                            "evalinkToken"
                          );
                        }}
                        helperText=""
                        stylingWidth={300}
                        label="Evalink Token"
                        error={false}
                      />
                    </div>
                    <div className="relative h-[75px]">
                      <MuiTextFieldType
                        id="evalinkDeviceIdInput"
                        defaultValue={evalinkAlertPostObject.evalink_device_id}
                        value=""
                        onChange={(event: any) => {
                          handleEvalinkInput(
                            setCamerasObject,
                            camerasObject,
                            event.target.value,
                            null,
                            "evalinkDeviceId"
                          );
                        }}
                        helperText=""
                        stylingWidth={300}
                        label="Evalink Device Id"
                        error={false}
                      />
                    </div>
                    <div className="relative h-[75px]">
                      <MuiTextFieldType
                        id="evalinkCompanyIdInput"
                        defaultValue={evalinkAlertPostObject.evalink_company_id}
                        value=""
                        onChange={(event: any) => {
                          handleEvalinkInput(
                            setCamerasObject,
                            camerasObject,
                            event.target.value,
                            null,
                            "evalinkCompanyId"
                          );
                        }}
                        helperText=""
                        stylingWidth={300}
                        label="Evalink Company Id"
                        error={false}
                      />
                    </div>
                    <div className="relative h-[75px]">
                      <MuiTextFieldType
                        id="evalinkPartitionIdInput"
                        defaultValue={evalinkAlertPostObject.partition_id}
                        value=""
                        onChange={(event: any) => {
                          handleEvalinkInput(
                            setCamerasObject,
                            camerasObject,
                            event.target.value,
                            null,
                            "partitionId"
                          );
                        }}
                        helperText="Applies to all cameras on this site. Each camera's Alarm Zone ID is set in the table above."
                        stylingWidth={300}
                        label="Evalink Partition Id"
                        error={false}
                      />
                    </div>
                    <br></br>
                  </div>
                )}
                {patriotSite && (
                  <div>
                    <p className="relative h-[35px] font-mulish w-[300px] text-[#283E6D] text-[18px]">
                      Patriot Alerts
                    </p>
                    <div className="relative h-[75px]">
                      <MuiTextFieldType
                        id="patriotServerInput"
                        defaultValue={patriotAlertPostObject.patriot_server}
                        value=""
                        onChange={(event: any) => {
                          handlePatriotInput(
                            setCamerasObject,
                            camerasObject,
                            event.target.value,
                            false,
                            null,
                            "patriotServer"
                          );
                        }}
                        helperText=""
                        stylingWidth={300}
                        label="Patriot Server"
                        error={false}
                      />
                    </div>
                    <div className="relative h-[75px]">
                      <MuiTextFieldType
                        id="patriotClientNoInput"
                        defaultValue={patriotAlertPostObject.patriot_client_no}
                        value=""
                        onChange={(event: any) => {
                          handlePatriotInput(
                            setCamerasObject,
                            camerasObject,
                            event.target.value,
                            false,
                            null,
                            "patriotClientNo"
                          );
                        }}
                        helperText=""
                        stylingWidth={300}
                        label="Patriot Client No"
                        error={false}
                      />
                    </div>
                    <div className="relative h-[75px]">
                      <MuiTextFieldType
                        id="patriotUsernameInput"
                        defaultValue={patriotAlertPostObject.patriot_username}
                        value=""
                        onChange={(event: any) => {
                          handlePatriotInput(
                            setCamerasObject,
                            camerasObject,
                            event.target.value,
                            false,
                            null,
                            "patriotUsername"
                          );
                        }}
                        helperText=""
                        stylingWidth={300}
                        label="Patriot Username"
                        error={false}
                      />
                    </div>
                    <div className="relative h-[75px]">
                      <MuiTextFieldType
                        id="patriotPasswordInput"
                        defaultValue={patriotAlertPostObject.patriot_password}
                        value=""
                        onChange={(event: any) => {
                          handlePatriotInput(
                            setCamerasObject,
                            camerasObject,
                            event.target.value,
                            false,
                            null,
                            "patriotPassword"
                          );
                        }}
                        helperText=""
                        stylingWidth={300}
                        label="Patriot Password"
                        error={false}
                      />
                    </div>
                    <div className="relative h-[75px]">
                      <MuiTextFieldType
                        id="patriotZoneNumberInput"
                        defaultValue={
                          patriotAlertPostObject.patriot_zone_number
                        }
                        value=""
                        onChange={(event: any) => {
                          handlePatriotInput(
                            setCamerasObject,
                            camerasObject,
                            event.target.value,
                            false,
                            null,
                            "patriotZoneNumber"
                          );
                        }}
                        helperText=""
                        stylingWidth={300}
                        label="Patriot Zone Number"
                        error={false}
                      />
                    </div>
                    <div className="relative h-[75px]">
                      <MuiTextFieldType
                        id="patriotTypeNumberInput"
                        defaultValue={
                          patriotAlertPostObject.patriot_type_number
                        }
                        value=""
                        onChange={(event: any) => {
                          handlePatriotInput(
                            setCamerasObject,
                            camerasObject,
                            event.target.value,
                            false,
                            null,
                            "patriotTypeNumber"
                          );
                        }}
                        helperText="Defaults to 100 if left blank."
                        stylingWidth={300}
                        label="Patriot Type Number"
                        error={false}
                      />
                    </div>
                    <div className="relative pb-2">
                      <PatriotDeliveryChoice
                        name="auto-add-patriot-delivery"
                        sendVideo={patriotAlertPostObject.patriot_send_video}
                        drawIgnoreZones={
                          patriotAlertPostObject.draw_ignore_zones
                        }
                        onChange={(values) => {
                          applyPatriotAlertPatch(
                            setCamerasObject,
                            camerasObject,
                            { ...values },
                            null
                          );
                        }}
                      />
                    </div>
                    <br></br>
                  </div>
                )}
                {hanwhaSite && (
                  <div>
                    <p className="relative h-[35px] font-mulish w-[300px] text-[#283E6D] text-[18px]">
                      {`Stream Parameters (optional)`}
                    </p>
                    <div className="relative h-[75px]">
                      <MuiTextFieldType
                        id="streamParamsResolution"
                        defaultValue=""
                        value=""
                        onChange={(event: any) => {
                          setStreamChangesMade(true);
                          setStreamPatchObject({
                            ...streamPatchObject,
                            resolution: event.target.value,
                          });
                        }}
                        helperText="Example: 720p"
                        stylingWidth={300}
                        label="Resolution"
                        error={false}
                      />
                    </div>

                    <div className="relative h-[75px]">
                      <MuiTextFieldType
                        id="streamParamsStreamType"
                        defaultValue=""
                        value=""
                        onChange={(event: any) => {
                          setStreamChangesMade(true);
                          setStreamPatchObject({
                            ...streamPatchObject,
                            stream_type: event.target.value,
                          });
                        }}
                        helperText="rtsp or http"
                        stylingWidth={300}
                        label="Stream Type"
                        error={false}
                      />
                    </div>
                    <div className="relative h-[75px]">
                      <MuiTextFieldType
                        id="streamParamsStreamQuality"
                        defaultValue=""
                        value=""
                        onChange={(event: any) => {
                          setStreamChangesMade(true);
                          setStreamPatchObject({
                            ...streamPatchObject,
                            stream_quality: event.target.value,
                          });
                        }}
                        helperText="For DW, 0 is high quality 1 is low quality. Preferably use 1."
                        stylingWidth={300}
                        label="Stream Quality"
                        error={false}
                      />
                    </div>
                    <br></br>
                    <div className="relative h-[75px]">
                      <MuiTextFieldType
                        id="streamParamsCodec"
                        defaultValue=""
                        value=""
                        onChange={(event: any) => {
                          setStreamChangesMade(true);
                          setStreamPatchObject({
                            ...streamPatchObject,
                            codec: event.target.value,
                          });
                        }}
                        helperText="Example: H264 for rtsp. For Http use webm, mpegts, mpjpeg, mp4 or mkv"
                        stylingWidth={300}
                        label="Codec"
                        error={false}
                      />
                    </div>

                    <br></br>
                  </div>
                )}
              </div>
            </div>
          </div>
        </ErrorBoundary>
      )}
    </div>
  );
};
